import React from 'react';
import { Navigate, Outlet, RouteObject } from 'react-router';

import { PermissionGuard, PermissionsFn } from '~/core/PermissionGuard';
import { Route as AccountingIntegrationsRoute } from '~/core/routes/settings/accounting-integrations/_index';
import { Router as AssignmentStrategyRouter } from '~/core/routes/settings/assignment-strategy/Router';
import { Route as BankAccountsRoute } from '~/core/routes/settings/bank-accounts/_index';
import { Route as BankIntegrationsRoute } from '~/core/routes/settings/bank-integrations/_index';
import { Router as CreditFacilitiesRouter } from '~/core/routes/settings/credit-facilities/Router';
import { Router as FundingRequestsRouter } from '~/core/routes/settings/funding-requests/Router';
import { Router as ImplementationsRouter } from '~/core/routes/settings/implementations/Router';
import { Route as MyAccountRoute } from '~/core/routes/settings/my-account/_index';
import { Route as NotificationsRoute } from '~/core/routes/settings/notifications/_index';
import { SettingsViewTemplate } from '~/core/routes/settings/SettingsTemplate';
import { Route as WebhookRoute } from '~/core/routes/settings/webhooks/_index';
// Exports
export const permissions: PermissionsFn = () => 'allow';
export const Router: RouteObject = {
  element: (
    <PermissionGuard
      permissions={permissions}
      fallback={<Navigate to="/" replace />}
    >
      <Outlet />
    </PermissionGuard>
  ),
  // Relative to /settings/*
  children: [
    {
      element: (
        <SettingsViewTemplate>
          <Outlet />
        </SettingsViewTemplate>
      ),
      children: [
        { path: 'my-account', element: <MyAccountRoute /> },
        { path: 'integrations', element: <MyAccountRoute /> },
        { path: 'bank-accounts', element: <BankAccountsRoute /> },
        { path: 'bank-integrations', element: <BankIntegrationsRoute /> },
        {
          path: 'accounting-integrations',
          element: <AccountingIntegrationsRoute />,
        },
        { path: 'notifications', element: <NotificationsRoute /> },
        { path: 'webhooks', element: <WebhookRoute /> },
        {
          path: 'assignment-strategy/*',
          children: [AssignmentStrategyRouter],
        },
        { path: 'funding-requests/*', children: [FundingRequestsRouter] },
        {
          path: 'implementations/*',
          children: [ImplementationsRouter],
        },
      ],
    },
    { path: 'credit-facilities/*', children: [CreditFacilitiesRouter] },
    { path: '*', element: <Navigate to="./my-account" replace /> },
  ],
};
